export const defaultStyle = {
    TopNavMainWrap:"TopNavMainWrap w-[66.66%] pl-[15px]",
    TopNavWrap:" TopNavWrap flex justify-between ",
    searchToggle:"TopNavWrapIN TopNavWrapSearch flex items-center relative",
    searchBar:"searchBar w-full flex  bg-repeat-x hidden",
    colofSearch:" colofSearch flex items-center flex-wrap m-0  lg:mx-auto justify-between relative  w-full  lg:max-w-lg xl:max-w-xl xl:w-full lg:px-[15px] items-center",
    searchBarContainer:"searchBarContainer w-full",
    stockTicker:"xl:font-Bold xl:text-[18px] xl:tracking-[1.8px] lg:min-h-[27px] lg:[&>p]:min-h-[27px]"
}